import {Component, EventEmitter, Output, Input} from '@angular/core';

@Component({
  selector: 'segment-report',
  templateUrl: './segment-report.template.html',
  styleUrls: ['./segment-report.component.css']
})
export class SegmentReportComponent {
  @Input() tranType: string = 'status';
  @Input() refCode: string;
  @Input() ids: string;
  @Input() email: string;
  ack: boolean = false;

  idType: string = 'ref'; // Remove @Input so it's a regular property for ngModel binding

  @Output() onPost: EventEmitter<any> = new EventEmitter();
  @Output() onOpenHelp: EventEmitter<string> = new EventEmitter();
  // This method should contain the logic for generating the report
  post(): void {
    // Handle the report generation logic here
    console.log('Generating report with the following data:', {
      tranType: this.tranType,
      idType: this.idType,
      refCode: this.refCode,
      ids: this.ids,
      email: this.email,
      ack: this.ack
    });

    this.onPost.emit({
      tranType: this.tranType,
      idType: this.idType,
      refCode: this.refCode,
      ids: this.ids,
      email: this.email,
      ack: this.ack
    });
  }

  // This method should handle the help dialog or instructions
  openHelp(section: string): void {
    this.onOpenHelp.emit(section);
  }
}
